'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _iBem = require('../../i-bem/i-bem.react');

var _iBem2 = _interopRequireDefault(_iBem);

var _eRadio = (require('./../__radio/radio-button__radio.react.js').default || require('./../__radio/radio-button__radio.react.js')).applyDecls();

var _eRadio2 = _interopRequireDefault(_eRadio);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PLATE_MARGIN = 3;

exports.default = (0, _iBem.declMod)({ view: 'default' }, {
    block: 'radio-button',
    willInit: function willInit() {
        this.__base.apply(this, arguments);

        this.state.plateLeft = PLATE_MARGIN;
        this.state.plateWidth = 0;
    },
    didMount: function didMount() {
        this.__base.apply(this, arguments);

        this._setPlate();
    },
    didUpdate: function didUpdate() {
        this.__base.apply(this, arguments);

        this._setPlate();
    },
    mods: function mods(_ref) {
        var tone = _ref.tone;

        return _extends({}, this.__base.apply(this, arguments), {
            tone: tone
        });
    },
    content: function content(_ref2) {
        var _this = this;

        var mainValue = _ref2.value;

        var children = this.__base.apply(this, arguments);
        var radios = 0;
        var width = 100;

        _react.Children.forEach(children, function (child) {
            if (_eRadio2.default.isRadio(child)) {
                radios++;
            }
        });

        width = (100 / (radios || 1)).toFixed(4);
        children = _react.Children.map(children, function (child) {
            if (!_eRadio2.default.isRadio(child)) {
                return;
            }

            var style = _extends({}, child.props.style);
            style.width = width + '%';

            var value = child.props.value || child.props.controlAttrs.value;
            var needRef = value !== undefined && value === mainValue;
            var ref = function ref(radio) {
                return _this._checked = radio;
            };

            // TODO: https://st.yandex-team.ru/ISL-4602
            return _react2.default.cloneElement(child, needRef ? { style: style, ref: ref } : { style: style });
        });

        var style = {
            left: this.state.plateLeft,
            width: this.state.plateWidth
        };

        return [_react2.default.createElement(_iBem2.default, { key: 'plate', block: 'radio-button', elem: 'plate',
            attrs: { style: style } }), children];
    },
    _setPlate: function _setPlate() {
        var checkedNode = _reactDom2.default.findDOMNode(this._checked);
        var plateLeft = checkedNode.offsetLeft + PLATE_MARGIN;
        var plateWidth = checkedNode.offsetWidth - PLATE_MARGIN * 2;

        if (this.state.plateLeft !== plateLeft || this.state.plateWidth !== plateWidth) {
            this.setState({ plateLeft: plateLeft, plateWidth: plateWidth });
        }
    }
}, {
    propTypes: {
        tone: _propTypes2.default.oneOf(['default', 'red', 'grey', 'dark'])
    },
    defaultProps: {
        tone: 'default'
    }
});